var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.31 20H2.5C1.39 20 0.5 19.11 0.5 18V2C0.5 0.9 1.39 0 2.5 0H10.5L16.5 6V11.09C16.17 11.04 15.84 11 15.5 11C15.16 11 14.83 11.04 14.5 11.09V7H9.5V2H2.5V18H9.59C9.71 18.72 9.96 19.39 10.31 20ZM19.5 16H16.5V13H14.5V16H11.5V18H14.5V21H16.5V18H19.5V16Z",
    fill: "black",
    fillOpacity: 0.38
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFile);
export default __webpack_public_path__ + "static/media/addFile.c012a2acb2723740bdf837709fac1f4c.svg";
export { ForwardRef as ReactComponent };